export const AppointmentColumns = (callbacks = {}) => [
  {
    header: "Appointment Title",
    value: "",
    columnName: "title",
    columnType: "text",
    draggable: false,
    width: 320,
    minWidth: 320,
    maxWidth: 320,
    order: 3,
  },
  {
    header: "Organizer",
    value: "",
    columnName: "organizer",
    order: 13,
    columnType: "select",
    minWidth: 100,
    draggable: false,
  },
  {
    header: "Guest",
    value: "",
    columnName: "guest",
    order: 13,
    columnType: "select",
    minWidth: 100,
    draggable: false,
  },
  {
    header: "Appointment Type",
    value: "",
    columnName: "serviceType",
    order: 13,
    columnType: "select",
    minWidth: 100,
    draggable: false,
  },
  {
    header: "Source",
    value: "",
    columnName: "leadSource",
    order: 14,
    columnType: "select",
    minWidth: 150,
    draggable: false,
  },
  {
    header: "Status",
    value: "",
    columnName: "status",
    order: 15,
    columnType: "select",
    minWidth: 100,
    draggable: false,
  },
];
